var _style, _polygon, _g, _polygon2, _path, _polygon3, _path2, _path3, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640.9 489.9",
    style: {
      enableBackground: "new 0 0 640.9 489.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;}\r\n\t.st1{fill:url(#Username_Panel_Part_2_);}\r\n\t.st2{fill:#70D5E5;}\r\n\t.st3{fill:none;stroke:#70D5E5;stroke-width:0.8078;stroke-miterlimit:10;}\r\n\t.st4{fill:url(#Username_Panel_Part_3_);}\r\n\t.st5{fill:url(#Username_Panel_Part_4_);}\r\n\t.st6{fill:url(#Username_Panel_Part_5_);}\r\n\t.st7{fill:url(#Username_Panel_Part_6_);}\r\n\t.st8{fill:url(#Username_Panel_Part_7_);}\r\n\t.st9{enable-background:new    ;}\r\n\t.st10{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Username_Panel_Part_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.2082,
    y1: 297.9948,
    x2: 319.0481,
    y2: 881.6989,
    gradientTransform: "matrix(1 0 0 1 0 -352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4D2AA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4517,
    style: {
      stopColor: "#2A1776"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    style: {
      stopColor: "#020142"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Username_Panel_Part_00000001643286390563329960000016665373728225368486_",
    className: "st1",
    points: "246.2,78.9  299.5,25.6 559.1,25.6 612.3,78.9 612.3,427.8 577.2,462.9 63.7,462.9 28.6,427.8 28.6,113.7 63.4,78.9  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Username_Panel_Part_00000104681825578744535510000015087104837104010408_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Username_Panel_Part_00000032606860208173190680000015531431342993674687_",
    className: "st2",
    points: "58.3,409.7  72.9,395.1 77.4,399.6 67.3,409.7 77.4,419.8 72.9,424.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Username_Panel_Part_00000083769465649640466070000007969465673357659807_",
    className: "st2",
    points: "75.1,409.7  89.7,395.1 94.2,399.6 84.1,409.7 94.2,419.8 89.7,424.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Username_Panel_Part_00000102545690427595684540000001966782279182993827_",
    className: "st3",
    points: "91.7,409.7  106.2,395.1 110.7,399.6 100.6,409.7 110.7,419.8 106.2,424.2 91.7,409.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Username_Panel_Part_00000044140335645162599740000014663804302964469908_",
    className: "st3",
    points: "108.4,409.7  123,395.1 127.5,399.6 117.4,409.7 127.5,419.8 123,424.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Username_Panel_Part_00000027599691277403147910000017243242227854140051_",
    className: "st2",
    points: "124.4,409.7  139,395.1 143.5,399.6 133.4,409.7 143.5,419.8 139,424.2  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Username_Panel_Part_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.5,
    y1: 398.85,
    x2: 272.4,
    y2: 398.85,
    gradientTransform: "matrix(1 0 0 1 0 -352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.026,
    style: {
      stopColor: "#9036BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    style: {
      stopColor: "#895AC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8229,
    style: {
      stopColor: "#76B6DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70D5E5"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Username_Panel_Part_00000014598482491330334080000000353438968655050678_",
    className: "st4",
    points: "235.9,65 75.5,64.6  111.4,28.7 272.4,28.7  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Username_Panel_Part_00000091736704355789263290000013841541615834943363_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Username_Panel_Part_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.4899,
    y1: 598.491,
    x2: 617.2173,
    y2: 595.2122,
    gradientTransform: "matrix(1 0 0 1 0 -352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.026,
    style: {
      stopColor: "#9036BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    style: {
      stopColor: "#895AC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8229,
    style: {
      stopColor: "#76B6DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70D5E5"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Username_Panel_Part_00000057111358074606696500000001397427413304804010_",
    className: "st5",
    d: "M578.9,466.9H62l-37.5-37.5 V112l37.2-37.2h182.8l53.3-53.3h262.9l55.6,55.6v352.2L578.9,466.9z M65.4,458.9h510.1l32.7-32.7V80.6l-50.9-50.9H301.1L247.8,83 H65.1l-32.4,32.4v310.7L65.4,458.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Username_Panel_Part_00000021094046164313982810000000693299269325713038_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Username_Panel_Part_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.8,
    y1: 597.1,
    x2: 588.1,
    y2: 597.1,
    gradientTransform: "matrix(1 0 0 1 0 -352)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.026,
    style: {
      stopColor: "#9036BF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274,
    style: {
      stopColor: "#895AC8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8229,
    style: {
      stopColor: "#76B6DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70D5E5"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Username_Panel_Part_00000101087161126841226830000009344352000712436110_",
    className: "st6",
    points: "562.2,438.4  561.9,438.4 85.7,436.7 85.7,435.1 561.5,436.7 586.5,412 586.5,94.8 543.8,53.4 313.1,53.4 260,105.4 259.6,105.4 76.5,105.2  54.4,130.1 54.4,389 52.8,389 52.8,129.5 75.8,103.5 76.2,103.5 259.3,103.8 312.4,51.8 544.5,51.8 588.1,94.1 588.1,412.7  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Username_Panel_Part_6_",
    cx: 99.6705,
    cy: 1335.6689,
    r: 344.1804,
    gradientTransform: "matrix(-0.4674 0 0 -2.480000e-02 477.786 55.7746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Username_Panel_Part",
    className: "st7",
    d: "M270.6,22.6c0-4.7,71.9-8.5,160.6-8.5s160.6,3.8,160.6,8.5s-71.9,8.5-160.6,8.5 C342.5,31.2,270.6,27.4,270.6,22.6z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Username_Panel_Part_7_",
    cx: 438.9944,
    cy: -16590.9434,
    r: 343.7767,
    gradientTransform: "matrix(-0.4674 0 0 -2.480000e-02 477.786 55.7746)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9995,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Username_Panel_Part_1_",
    className: "st8",
    d: "M112,467.2c0-4.7,71.9-8.5,160.6-8.5s160.6,3.8,160.6,8.5s-71.9,8.5-160.6,8.5 S112,471.9,112,467.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M141.3,227.9V240H163v8.5h-21.7v16.7h-10.9v-45.7h35.5v8.5h-24.6V227.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M209.7,256.6v8.5h-36.3v-45.7h35.5v8.5h-24.7v9.9H206v8.2h-21.8v10.6H209.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M254.7,256.6v8.5h-36.3v-45.7h35.5v8.5h-24.7v9.9H251v8.2h-21.8v10.6H254.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M263.3,219.4h21.3c5.1,0,9.6,0.9,13.5,2.8c3.9,1.9,7,4.6,9.1,8c2.2,3.4,3.3,7.4,3.3,12s-1.1,8.6-3.3,12 c-2.2,3.4-5.2,6.1-9.1,8c-3.9,1.9-8.4,2.8-13.5,2.8h-21.3V219.4z M284.1,256.4c4.7,0,8.4-1.3,11.2-3.8c2.8-2.5,4.2-6,4.2-10.4 s-1.4-7.8-4.2-10.4c-2.8-2.5-6.5-3.8-11.2-3.8h-9.9v28.4H284.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M359.5,245.5c1.5,1.9,2.3,4.3,2.3,7.2c0,4-1.6,7.1-4.8,9.2c-3.2,2.2-7.9,3.2-14,3.2h-24.3v-45.7h22.9 c5.7,0,10.1,1.1,13.2,3.2c3.1,2.1,4.6,5,4.6,8.7c0,2.2-0.5,4.2-1.6,5.9s-2.6,3.1-4.6,4.1C355.8,242.2,357.9,243.6,359.5,245.5z  M329.5,227.4v10.8h10.8c2.7,0,4.7-0.5,6.1-1.4s2.1-2.3,2.1-4c0-1.8-0.7-3.1-2.1-4s-3.4-1.3-6.1-1.3h-10.8V227.4z M348.6,255.8 c1.5-0.9,2.2-2.3,2.2-4.2c0-3.8-2.9-5.7-8.7-5.7h-12.7v11.3h12.7C345,257.2,347.2,256.7,348.6,255.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M400.9,255.3h-21.8l-4.2,9.8h-11.1l20.9-45.7h10.7l21,45.7H405L400.9,255.3z M397.5,247.3l-7.4-17.5 l-7.4,17.5H397.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M430.2,262.9c-3.9-2-6.9-4.8-9.1-8.4s-3.3-7.7-3.3-12.2s1.1-8.6,3.3-12.2c2.2-3.6,5.3-6.4,9.1-8.4 c3.9-2,8.2-3,13-3c4.1,0,7.7,0.7,11,2.1c3.3,1.4,6,3.4,8.3,6l-7,6.3c-3.2-3.6-7.1-5.4-11.8-5.4c-2.9,0-5.5,0.6-7.8,1.9 c-2.3,1.2-4.1,3-5.3,5.2c-1.3,2.2-1.9,4.7-1.9,7.6c0,2.8,0.6,5.4,1.9,7.6s3.1,4,5.3,5.2c2.3,1.2,4.9,1.9,7.8,1.9 c4.7,0,8.6-1.8,11.8-5.4l7,6.3c-2.2,2.7-5,4.7-8.3,6.1s-7,2.1-11.1,2.1C438.4,265.9,434,264.9,430.2,262.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M486.9,247.2l-6.3,6.4v11.6h-10.8v-45.7h10.8v21.4l20.8-21.4h12.1L494,239.8l20.6,25.3H502L486.9,247.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M229.8,314.3v12.1h21.7v8.5h-21.7v16.7h-10.9v-45.7h35.5v8.5h-24.6V314.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M270.8,349.3c-3.9-2-7-4.9-9.2-8.5s-3.3-7.6-3.3-12.1s1.1-8.5,3.3-12.1c2.2-3.6,5.3-6.4,9.2-8.5 c3.9-2,8.3-3.1,13.2-3.1c4.9,0,9.3,1,13.1,3.1c3.9,2,7,4.9,9.2,8.5s3.4,7.6,3.4,12.1s-1.1,8.5-3.4,12.1c-2.2,3.6-5.3,6.4-9.2,8.5 c-3.9,2-8.3,3.1-13.1,3.1C279.1,352.4,274.8,351.3,270.8,349.3z M291.5,341.5c2.2-1.2,4-3,5.3-5.2s1.9-4.7,1.9-7.6 c0-2.8-0.6-5.4-1.9-7.6s-3-4-5.3-5.2c-2.2-1.2-4.7-1.9-7.5-1.9s-5.3,0.6-7.5,1.9c-2.2,1.2-4,3-5.3,5.2s-1.9,4.7-1.9,7.6 c0,2.8,0.6,5.4,1.9,7.6s3,4,5.3,5.2c2.2,1.2,4.7,1.9,7.5,1.9C286.8,343.3,289.3,342.7,291.5,341.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M347.8,351.6l-9.1-12.7h-0.5h-9.5v12.7h-10.9v-45.7h20.3c4.2,0,7.8,0.7,10.8,2c3.1,1.4,5.4,3.3,7.1,5.7 c1.7,2.5,2.5,5.4,2.5,8.8s-0.8,6.3-2.5,8.8s-4.1,4.3-7.1,5.7l10.5,14.7H347.8z M345,316.5c-1.7-1.4-4.2-2.1-7.4-2.1h-8.9v15.9h8.9 c3.3,0,5.7-0.7,7.4-2.1c1.7-1.4,2.5-3.4,2.5-5.9C347.6,319.9,346.7,317.9,345,316.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M409.9,351.6l-0.1-27.4L396,346.7h-4.9l-13.7-22v26.8h-10.2v-45.7h9l17.6,28.4l17.3-28.4h8.9l0.1,45.7h-10.2 V351.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.19abefef15bd8e5aab24c21ae19e3df1.svg";
export { ForwardRef as ReactComponent };